export default {
    modal: {
        header: {
            text: "Estados de Cuenta",
        },
        popUpBlockerTitle: "¿Tiene problemas para abrir su estado de cuenta?",
        popUpBlockerDescription: "Por favor revise las configuraciones del navegador para asegurar que las ventanas emergentes no estén bloqueadas.",
        paperLanguage: {
            A: {
                text: "Actualmente, está inscrito en Estados de Cuenta en Papel que incluye una <strong>Tarifa por Estado de Cuenta en Papel mensual de $1.99</strong>. Cargaremos esta tarifa en cualquier ciclo de facturación cuyo saldo sea mayor que $2.50 y se le envíe un estado de facturación mensual en papel (incluso si a usted también se le envía en formato electrónico). Usted puede evitar esta tarifa si configura Estados de Cuenta Electrónicos y sus estados de cuenta solo son envíados en formato electrónico. \n \n Al elegir Estados de Cuenta Electrónicos, confirma su <consentLink>Consentimiento para Recibir Comunicaciones Electrónicas</consentLink>. Recibirá un mensaje de correo electrónico notificándole cuando su Estado de Cuenta Electrónico esté disponible en línea. Ya no recibirá estados de cuenta en papel.",
            },
            B: {
                text: "Si selecciona Estados de Cuenta En Papel, recibirá estados de cuenta en papel a través del correo postal de EE. UU. en el futuro. Continuará teniendo acceso a sus Estados de Cuenta Electrónicos en línea y recibirá una notificación por correo electrónico cuando estén listos para ver. \n \n Se cargará a su cuenta una <strong>Tarifa por Estados de Cuenta en Papel mensual de $1.99</strong>. Le cargaremos esta tarifa en cualquier ciclo de facturación cuyo saldo sea mayor que $2.50 y se le envíe un estado de cuenta de facturación mensual en papel (incluso si a usted también se le envía en formato electrónico). Usted puede evitar esta tarifa si configura estados de cuenta electrónicos y sus estados de cuenta solo son enviados en formato electrónico.",
            },
            C: {
                text: "¿Está seguro de que desea desactivar los Estados de Cuenta Electrónicos? Comenzará a recibir estados de cuenta en papel a través del correo postal de EE. UU. en el futuro. Ya no tendrá acceso a estados de cuenta electrónicos anteriores en línea ni recibirá notificaciones por correo electrónico. \n \n Se cargará a su cuenta una <strong>Tarifa por Estados de Cuenta en Papel mensual de $1.99</strong>. Le cargaremos esta tarifa en cualquier ciclo de facturación cuyo saldo sea mayor que $2.50 y se le envíe un estado de facturación mensual en papel (incluso si a usted también se le envía en formato electrónico). Usted puede evitar esta tarifa si configura Estados de Cuenta Electrónicos y sus estados de cuenta solo son enviados en formato electrónico.",
            },
            D: {
                text: "Si selecciona Estados de Cuenta En Papel, recibirá estados de cuenta en papel a través del correo postal de EE. UU. en el futuro. Continuará teniendo acceso a sus Estados de Cuenta Electrónicos en línea y recibirá una notificación por correo electrónico cuando estén listos para ver.",
            },
            E: {
                text: 'Al elegir Estados de Cuenta Electrónicos, confirma su <consentLink>Consentimiento para Recibir Comunicaciones Electrónicas</consentLink>. Recibirá un mensaje de correo electrónico notificándole cuando su Estado de Cuenta Electrónico esté disponible en línea. Inicie sesión en el sitio del servicio y haga clic en el enlace "Estados de Cuenta" para ver sus Estados de Cuenta Electrónicos. Ya no recibirá estados de cuenta en papel.',
            },
            F: {
                text: "¿Está seguro que desea desactivar los estados de cuenta electrónicos? Comenzará a recibir estados de cuenta impresos mediante el correo postal y ya no tendrá acceso a los estados de cuenta anteriores en línea.",
            },
        },
        enroll: {
            title: "Suscríbase para Recibir Estados de Cuenta Electrónicos",
            consent: 'Al seleccionar "Estados de Cuenta Electrónicos", usted acepta estos términos de <consentLink>Consentimiento para Recibir Comunicaciones Electrónicas</consentLink> sobre su cuenta.',
            button: "ESTADOS DE CUENTA ELECTRÓNICOS",
            error: {
                title: "La inscripción no está disponible actualmente.",
                description: "Vuelva a consultar más tarde para cambiar su inscripción.",
            },
            delinquent: "Debido al estado de su cuenta, la inscripción a estados de cuenta electrónicos se encuentra actualmente desactivada.",
            error24Hour: "Debe esperar 24 horas antes de tratar de inscribirse nuevamente en Estados de Cuenta Electrónicos.",
        },
        alreadyEnrolled: {
            title: "Ahora está inscrito para recibir los estados de cuenta electrónicos.",
            body: "Recibirá un correo electrónico cuando haya nuevos estados de cuenta electrónicos disponibles para ver y descargar. Solo los futuros estados de cuenta mensuales estarán disponibles electrónicamente.",
            email: "Dirección de Correo Electrónico:",
            editEmail: "Editar correo electrónico",
            link: "Desactivar los estados de cuenta electrónicos",
            paperStatements: "Recibir estados de cuenta en papel",
        },
        bothEnrolled: {
            title: "Está inscrito para recibir los estados de cuenta electrónicos y estados de cuenta en papel.",
            turnOffPaper: "Desactivar los estados de cuenta en papel",
        },
        paperStatements: {
            title: "Recibir estados de cuenta en papel",
            mailPaper: "Sí, Enviar los estados de cuenta en papel por correo",
            stayPaperless: "No, Continuar con los estados de cuenta electrónicos",
        },
        footer: {
            closeButton: "Cerrar",
        },
        table: {
            balance: "Saldo del Estado de Cuenta",
            caption: "Los estados de cuenta que faltan pueden deberse a una falta de actividad o a cambios en el estatus de su inscripción de Estados de Cuenta Electrónicos.",
            date: "Fecha del Estado de Cuenta",
            privacy: "Política de Privacidad",
            statement: "Estado de Cuenta",
            insert: "Anexo",
            changeOfTerms: "Incluye un cambio en los términos. Abra el documento para revisarlo.",
            tokenError: "Este estado de cuenta no está disponible actualmente.",
            insertError: "Este anexo no está disponible actualmente.",
        },
        noStatements: {
            title: "No Hay Estados de Cuenta Disponibles",
            notAvailable: "Actualmente, está recibiendo estados de cuenta impresos por correo.",
            notRecent: "Cuando estén disponibles, podrá ver y descargar estados de cuenta en formato PDF desde esta página.",
        },
        statementsDown: {
            title: "Los estados de cuenta no están disponibles",
            description: "Por favor, intente nuevamente más tarde.",
        },
        unenrollConfirm: {
            title: "Desactivar el estado de cuenta electrónico",
            buttonLeavePaperless: "DEJAR ACTIVOS LOS ESTADOS DE CUENTA ELECTRÓNICOS",
            buttonDoNotLeavePaperless: "DESACTIVAR LOS ESTADOS DE CUENTA ELECTRÓNICOS",
        },
        unenrollPaperConfirm: {
            title: "Desactivar estados de cuenta impresos",
            buttonLeavePaper: "Dejar activos los estados de cuenta impresos",
            buttonTurnPaperOff: "Desactivar estados de cuenta impresos",
        },
    },
    drawerHeader: {
        title: "Cuenta de SetPay",
        subtitle: {
            account: "Cuenta que termina en {{accountLast4}}",
            loan: "Préstamo que termina en {{accountLast4}}",
        },
    },
    error: {
        api: {
            title: "Detalles de la Cuenta no Disponibles",
        },
        default: {
            title: "¡Lo sentimos, hubo un problema!",
            subtitle: "Lo sentimos, estamos teniendo dificultades para obtener esta información. Por favor, actualice la página o vuelva a intentarlo más tarde.",
        },
        uiComponent: "No Disponible",
        littleTrouble: "Lo sentimos, estamos teniendo un poco de dificultades para obtener esta información.",
        pleaseReload: "Por favor, refresque la página o intente de nuevo más tarde. Si el problema continúa,",
        pageNotFound: "La página que está buscando o no existe o no pudo ser encontrada.",
        sorryPage: "Lo sentimos, no pudimos encontrar esta página.",
        weApologize: "Nos disculpamos",
        technicalDifficulties: "Estamos experimentando dificultades técnicas en este momento y no podemos accesar a su cuenta.",
        unableToFindAccount: "Aunque su acceso fue exitoso, no podemos encontrar la cuenta asociada con sus credenciales.",
        tryAgain: "Vuelve a intentar",
        tryAgainLater: "Por favor, intente más tarde, o contacte a servicio al cliente para asistencia.",
        accountClosedOrBlocked: "Esta cuenta puede haber sido cerrada o bloqueada.",
        contactCustomerService: "Por favor, comuníquese con servicio al cliente al número que está al reverso de su tarjeta.",
    },
    footer: {
        body: "Sus cuentas de crédito son emitidas por Synchrony Bank. La Política de Privacidad de Synchrony Bank rige el uso sus cuentas de crédito. El uso de este sitio se rige por el uso de la Política de Privacidad de Internet de Synchrony Bank. Es posible que el contenido y los documentos que se muestran pueden no se proporcionen en español.",
        privacyPolicy: "Política de Privacidad en Línea",
        privacyPolicyLink: "privacy-policy-sp.html",
        usageAgreement: "Acuerdo de uso en Línea",
        usageAgreementLink: "terms-of-use-sp.html",
        fraudProtection: "Protección contra Fraude",
        fraudProtectionlink: "fraud-protection-sp.html",
        accessibility: "Accesibilidad",
        accessibilityLink: "gwas-sp",
    },
    button: {
        accountManager: "ADMINISTRADOR DE CUENTA",
        alertsTooltip: "Administrar inscripciones de Alertas",
        clickHere: "Hacer clic aquí",
        makeAPayment: "Realizar un pago",
        paymentOptions: "Ver Opciones de Pago",
        paymentPlan: "Ver el Plan de Pagos ",
        reload: "Refrescar",
        signOut: "Cerrar sesión",
        activity: "ACTIVIDAD",
        back: "ATRÁS",
        goBackHome: "Regresar a la Página Principal",
        languageText: "English",
        close: "cerrar",
        agreeAndContinue: "ACEPTAR Y CONTINUAR",
        welcomeConfirmation: "¡ENTENDIDO!",
        registerAccount: "Registre la cuenta",
        viewMyAccount: "Ver Mi Cuenta",
        statements: "ESTADOS DE CUENTA",
        rewards: "RECOMPENSAS",
        accountDetails: "DETALLES",
        viewAllActivity: "Ver Toda la Actividad",
        activateCard: "Activar Tarjeta",
        profileToolTip: "Administre el perfil o cierre sesión",
        profileManagement: "Administración de Perfil",
    },
    logout: {
        pageTitle: "Se ha cerrado la sesión",
        cardTitle: "Gracias por administrar sus cuentas de Synchrony.",
        cardDescription: "Se ha cerrado la sesión de forma segura.",
        button: "INICIE SESIÓN DE NUEVO",
    },
    login: {
        loginText: "Iniciar Sesión",
    },
    labels: {
        accountEndingIn: "Cuenta que termina en",
        loanEndingIn: "Préstamo que termina en",
        dueDate: "Fecha de pago",
        monthlyPaymentAmount: "Monto del pago mensual",
        totalMinimumPayment: "Total del Pago mínimo",
        noPaymentDue: "No Hay un Pago a Vencer",
        forHelp: "para obtener ayuda.",
        creditLimit: "Límite de Crédito",
        currentBalance: "Saldo Actual",
        totalPaid: "Total Pagado",
        availableToSpend: "Disponible para gastar",
        accountSnapshot: "RESUMEN DE LA CUENTA",
        totalRemaining: "Saldo Restante",
        monthlyPayment: " Pago Mensual",
        currentBalanceTooltip: "Podría no reflejar transacciones recientes.",
        unavailable: "No disponible",
        recentActivity: "Actividad Reciente",
        currentBalanceAlt: "Información sobre Saldo Actual",
    },
};
